/**
 * Shared frontend functionality for sections.
 */
(function($, document, window) {
	$(document).ready(function() {

		if ($('body').hasClass('not-logged-in')) {
			// Functionality when user is not logged in

		}
	});
})(jQuery, document, window);